import React, { Fragment } from 'react';
import { number, string, func, bool } from 'prop-types';
import { useTranslation } from 'react-i18next';

// eden
import { Primary, Secondary } from '@churchofjesuschrist/eden-buttons';

// components
import ErrorModal from 'src/components/Modals/ErrorModal/ErrorModal';
import LoadingSpinner from 'src/utils/componentFunctions/loading-spinner';

// constants
import { pageNames } from 'src/utils/appConstants/appConstants';
import { ApolloError } from '@apollo/client';

const { managePublishPageName, createPageName } = pageNames;

export const SaveStoryButton = ({
  currentPageName,
  index = 0,
  disabled = false,
  handleSaveStory,
  loading,
  error,
}: {
  currentPageName?
  index?
  disabled?
  handleSaveStory?
  loading
  error
}) => {
  const { t } = useTranslation();

  if (loading) return <LoadingSpinner />;

  if (error) {
    return (
      <ErrorModal
        title={t('errorSavingStoryLabel')}
        onRetry={handleSaveStory}
        errors={error}
        isActive
      />
    );
  }

  return (
    <Fragment>
      {currentPageName === createPageName
        ? (
          <Fragment>
            <Primary
              onClick={handleSaveStory}
              data-test-id={`saveStoryBtn${index}`}
              disabled={disabled}
            >
              {t('createContinueBtnLabel', { ns: 'labels' })}
            </Primary>
            <Secondary
              onClick={() => {
                window.history.go(-1);
              }}
              data-test-id={`cancelStoryBtn${index}`}
            >
              {t('createCancelBtnLabel', { ns: 'labels' })}
            </Secondary>
          </Fragment>
        )
        : (
          <React.Fragment>
            <Secondary
              onClick={handleSaveStory}
              data-test-id={`saveStoryBtn${index}`}
              disabled={disabled}
            >
              {currentPageName === managePublishPageName ? t('saveBtnLabel', { ns: 'labels' }) : t('saveAsDraftBtnLabel', { ns: 'labels' })}
            </Secondary>
          </React.Fragment>
        )}
    </Fragment>
  );
};

export default SaveStoryButton;

SaveStoryButton.propTypes = {
  currentPageName: string.isRequired,
  index: number.isRequired,
  disabled: bool,
  handleSaveStory: func.isRequired,
  loading: bool.isRequired,
  error: ApolloError,
};
